// src/pages/Dashboard/Admin/SeasonStats/components/SeasonStatsKpiCards.jsx

import React from "react";

import {
  FaFemale,
  FaMale,
  FaUsers,
  FaLayerGroup,
} from "react-icons/fa";

function SkeletonCard() {
  return (
    <div className="h-32 animate-pulse rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900" />
  );
}

function KpiCard({
  label,
  value,
  helper,
  icon,
  tone,
}) {
  const tones = {
    blue:
      "bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300",

    pink:
      "bg-pink-50 text-pink-700 dark:bg-pink-500/10 dark:text-pink-300",

    cyan:
      "bg-cyan-50 text-cyan-700 dark:bg-cyan-500/10 dark:text-cyan-300",

    green:
      "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
  };

  return (
    <article className="rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            {label}
          </p>

          <p className="mt-2 text-2xl font-bold text-slate-900 dark:text-white">
            {value}
          </p>

          <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
            {helper}
          </p>
        </div>

        <span
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${
            tones[tone] || tones.blue
          }`}
        >
          {icon}
        </span>
      </div>
    </article>
  );
}

export default function SeasonStatsKpiCards({
  summary,
  loading,
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        label="Adhérents"
        value={summary.total}
        helper="Effectif enregistré pour la saison."
        icon={<FaUsers />}
        tone="blue"
      />

      <KpiCard
        label="Filles"
        value={summary.female}
        helper={`${summary.femalePercent}% des genres renseignés.`}
        icon={<FaFemale />}
        tone="pink"
      />

      <KpiCard
        label="Garçons"
        value={summary.male}
        helper={`${summary.malePercent}% des genres renseignés.`}
        icon={<FaMale />}
        tone="cyan"
      />

      <KpiCard
        label="Remplissage groupes"
        value={`${summary.averageFillRate}%`}
        helper={`${summary.groupsCount} groupe(s), ${summary.fullGroups} complet(s).`}
        icon={<FaLayerGroup />}
        tone="green"
      />
    </div>
  );
}